import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchAdminLeads,
  updateAdminLead,
  markLeadAsSpam,
  deleteAdminLead,
  type AdminLead,
  type LeadFilters,
  type LeadStatus,
} from '../api/adminLeads';

export function useAdminLeads(filters: LeadFilters) {
  return useQuery<AdminLead[]>({
    queryKey: ['admin-leads', filters],
    queryFn: () => fetchAdminLeads(filters),
    staleTime: 1000 * 30,
  });
}

export function useUpdateLead(filters: LeadFilters) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status, notes }: { id: string; status: LeadStatus; notes?: string }) =>
      updateAdminLead(id, { status, notes }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-leads', filters] });
    },
  });
}

export function useSpamLead(filters: LeadFilters) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => markLeadAsSpam(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-leads', filters] });
    },
  });
}

export function useDeleteLead(filters: LeadFilters) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteAdminLead(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-leads', filters] });
    },
  });
}
